import { inject, Injectable } from '@angular/core';

import { SeamlyEnvironment } from '../src/klant/conversational-connector/klant-conversational-connector.model';
import { SessionStorageService } from '../src/session-storage/session-storage.service';

const LD_USER_ID_KEY = 'ld:$anonUserId';
const LD_DEV_USER_ID = 'CONVERSATIONAL-DEV-USER-ID';
const LOCAL_HOST = 'localhost:9905';

@Injectable({ providedIn: 'root' })
export class DebugUtilsService {
    private readonly sessionStorageService = inject(SessionStorageService);

    public static getIsOta(): boolean {
        const boolIsOta: string = '{<BOOL_IS_OTA>}';
        return window.location.host === LOCAL_HOST || boolIsOta === 'true';
    }

    public toggleEnvironment(currentEnvironment: SeamlyEnvironment) {
        if (currentEnvironment === 'TST') {
            localStorage.setItem(LD_USER_ID_KEY, LD_DEV_USER_ID);
        } else {
            localStorage.removeItem(LD_USER_ID_KEY);
        }
        this.sessionStorageService.updateConversationSessionDetails(undefined);
        this.sessionStorageService.updateSeamlyEnvironmentConfig(undefined);

        window.location.reload();
    }
}
